import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./Components/AuthContext";
import { PanierContextProvider } from "./Store/Panier_context";
import { FavoriteContextProvider } from "./Store/Favoris_context";
import { Provider } from "react-redux";
import { store } from "./Store/Store";
import { ImageCacheProvider } from "./Store/ImageCacheContext";
import { HelmetProvider } from 'react-helmet-async';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ImageCacheProvider>
        <Router>
          <AuthProvider>
            <PanierContextProvider>
              <Provider store={store}>
                <FavoriteContextProvider>
                  <App />
                </FavoriteContextProvider>
              </Provider>
            </PanierContextProvider>
          </AuthProvider>
        </Router>
      </ImageCacheProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
